import API_URLS from '~/core/api-urls'
import { MEETING_SETTINGS_PRESET } from '~/core/constants'
import { getIsLoggedIn } from '~/selectors/salesforce'
import { getHasSalesforceIntegration } from '~/selectors/settings'

const getState = state => state.roomSettings

export const isUndockedEnabled = state => getState(state).enableUndocked
export const selectMeetingPreviewEnabled = state => getState(state).isMeetingPreviewEnabled

export const getSalesforceUrl = state =>
  getHasSalesforceIntegration(state) &&
  getIsLoggedIn(state) &&
  API_URLS.SALESFORCE.URL

export const getUser = state => getState(state).userIdentity
export const getAccessSettings = state => getState(state).access
export const getRecordingSettings = state => getState(state).recordings
export const getModerationSettings = state => getState(state).moderation
export const getSecuritySettings = state => getState(state).security
export const getOverridePermissions = state => getState(state).overridePermissions

export const getSelectedPreset = state => getState(state).intendedPreset
export const isLargePreset = state => getSelectedPreset(state) === MEETING_SETTINGS_PRESET.LARGE.value
export const isPublicPreset = state => getSelectedPreset(state) === MEETING_SETTINGS_PRESET.PUBLIC.value
